import './PlanSelectionContent.scss';

import { isDefaultBrand, ProductOffering, useConfig } from '@travelwin/core';

import {
  HelpCentre,
  PlanSelectionCountry,
  TestimonialItem,
} from '@/interfaces/cms';

import { PageBlocks } from '../../../../../app/components/PageLayout';
import { ShowTo } from '../../../../components/ShowTo';
import B2BLandingFAQ from '../../../Landing/components/B2BLandingFAQ';
import LandingFAQ from '../../../Landing/components/LandingFAQ';
import { LandingFindMyPlan } from '../../../Landing/components/LandingFindMyPlan';
import LandingGetMoreSection from '../../../Landing/components/LandingGetMoreSection/LandingGetMoreSection';
import LandingHelp from '../../../Landing/components/LandingHelp';

type Props = {
  cmsContent?: PlanSelectionCountry;
  testimonials?: TestimonialItem[];
  plans?: ProductOffering[];
  helpCentre?: HelpCentre;
};

const className = 'c-PlanSelectionContent';

export const PlanSelectionContent = ({
  cmsContent,
  plans,
  testimonials,
  helpCentre,
}: Props) => {
  const { WHITELABEL_BRAND, FIND_MY_PLAN_ENABLED } = useConfig();

  const renderSimlocalCmsContentFallback = () => {
    return (
      <>
        {FIND_MY_PLAN_ENABLED ? (
          <div className={`${className}__find-my-plan`}>
            <div className="bg-white">
              <LandingFindMyPlan />
            </div>
          </div>
        ) : null}
        <div className="bg-primary">
          <LandingGetMoreSection />
        </div>
        <div className="bg-white">
          <LandingFAQ />
        </div>
      </>
    );
  };

  return (
    <>
      <ShowTo brand="simlocal">
        {cmsContent?.layout && cmsContent.layout.length > 0 ? (
          <PageBlocks
            blocks={cmsContent.layout}
            plans={plans || []}
            testimonials={testimonials || []}
          />
        ) : (
          renderSimlocalCmsContentFallback()
        )}

        <LandingHelp helpCentre={helpCentre} />
      </ShowTo>

      {!isDefaultBrand(WHITELABEL_BRAND) && (
        <div className="bg-white">
          <div className={`${className}__b2b-landing-bottom-spacing`}>
            <B2BLandingFAQ />
          </div>
        </div>
      )}
    </>
  );
};
